import { render } from "./EditarServicos.vue?vue&type=template&id=a754f3c4"
import script from "./EditarServicos.vue?vue&type=script&lang=js"
export * from "./EditarServicos.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/alperlab/alperlab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__